var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M138.987,244.276L0,0v512l138.987-244.276C142.898,260.85,142.898,251.15,138.987,244.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M252.767,268.052c0,0.33-0.107,32.004-8.208,47.585h22.761c-8.101-15.581-8.208-47.256-8.208-47.585  c0-10.914,11.311-19.586,11.425-19.672l-3.812-5.071c-0.297,0.223-4.066,3.112-7.613,7.807v-8.442h-6.345v8.442  c-3.548-4.695-7.317-7.584-7.613-7.807l-3.812,5.071C241.456,248.466,252.767,257.138,252.767,268.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M287.663,229.984c-0.194,0-0.373,0.051-0.563,0.063c-1.293-3.72-4.793-6.407-8.954-6.407  c-1.5,0-2.9,0.378-4.162,0.996c-1.343-2.471-3.931-4.169-6.941-4.169c-0.865,0-1.683,0.173-2.463,0.429  c-1.687-3.981-5.631-6.774-10.227-6.774c-5.648,0-10.261,4.234-10.961,9.691c-0.567-0.089-1.136-0.174-1.729-0.174  c-6.132,0-11.103,4.971-11.103,11.103c0,0.72,0.081,1.421,0.212,2.103c-2.809,0.925-5.02,3.097-5.992,5.885  c-0.189-0.017-0.372-0.057-0.565-0.057c-3.504,0-6.345,2.84-6.345,6.345c0,3.504,2.841,6.345,6.345,6.345  c1.619,0,3.08-0.625,4.201-1.623c1.518,1.024,3.347,1.623,5.316,1.623c1.742,0,3.354-0.502,4.759-1.32  c1.405,0.817,3.016,1.32,4.759,1.32c5.256,0,9.517-4.261,9.517-9.517c0-0.402-0.07-0.785-0.118-1.174  c1.478,0.728,3.118,1.174,4.877,1.174c2.206,0,4.25-0.662,5.978-1.771c1.621,2.934,4.709,4.944,8.298,4.944  c0.772,0,1.512-0.117,2.23-0.29c1.746,2.099,4.344,3.463,7.287,3.463c2.844,0,5.367-1.272,7.111-3.25  c4.891-0.397,8.751-4.446,8.751-9.44C297.18,234.245,292.919,229.984,287.663,229.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5FA000"
    },
    d: "M278.146,237.914c0-0.33,0.069-0.641,0.097-0.964c-1.697,1.57-3.948,2.55-6.442,2.55  c-3.314,0-6.227-1.698-7.931-4.268c-1.704,2.57-4.616,4.268-7.931,4.268c-2.548,0-4.85-1.015-6.558-2.646  c-0.988,5.12-5.482,8.99-10.89,8.99c-0.549,0-1.075-0.085-1.602-0.161c0.001,0.055,0.016,0.106,0.016,0.161  c0,4.148-2.67,7.64-6.373,8.943c1.003,0.359,2.074,0.574,3.2,0.574c1.742,0,3.354-0.502,4.759-1.32  c1.405,0.817,3.016,1.32,4.759,1.32c5.256,0,9.517-4.261,9.517-9.517c0-0.402-0.07-0.785-0.118-1.174  c1.478,0.728,3.118,1.174,4.877,1.174c2.206,0,4.25-0.662,5.978-1.771c1.621,2.934,4.709,4.944,8.298,4.944  c0.772,0,1.512-0.117,2.23-0.29c1.746,2.099,4.344,3.463,7.287,3.463c2.844,0,5.367-1.272,7.111-3.25l0.02-0.003  C282.697,248.52,278.146,243.772,278.146,237.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M255.939,335.858c-0.51,0-0.962-0.325-1.128-0.805c-0.121-0.356-3.107-8.708-14.734-8.708h-15.862  c-9.402,0-17.051-7.649-17.051-17.051V204.605c0-0.657,0.533-1.19,1.19-1.19h98.343c0.657,0,1.19,0.533,1.19,1.19v104.688  c0,9.402-7.649,17.051-17.051,17.051h-19.034c-11.697,0-14.705,8.616-14.733,8.702c-0.163,0.486-0.615,0.812-1.126,0.812H255.939z   M209.543,205.794v103.498c0,8.089,6.582,14.672,14.672,14.672h15.862c9.416,0,13.974,5.056,15.862,8.095  c1.888-3.039,6.445-8.095,15.862-8.095h19.034c8.09,0,14.672-6.583,14.672-14.672V205.794H209.543z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "243.765,176.318 246.778,181.144 252.465,181.341 249.792,186.364 252.465,191.387    246.778,191.584 243.765,196.409 240.751,191.584 235.065,191.387 237.737,186.364 235.065,181.341 240.751,181.144  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "216.965,180.693 221.022,184.682 226.597,183.545 225.172,189.053 228.943,193.313    223.461,194.833 221.657,200.229 217.6,196.241 212.025,197.377 213.45,191.869 209.678,187.609 215.161,186.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "191.251,188.304 196.074,191.322 201.272,189.009 201.069,194.695 205.672,198.04    200.646,200.707 200.05,206.366 195.227,203.347 190.029,205.661 190.232,199.975 185.629,196.63 190.655,193.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "268.235,176.318 265.222,181.144 259.535,181.341 262.208,186.364 259.535,191.387    265.222,191.584 268.235,196.409 271.249,191.584 276.935,191.387 274.263,186.364 276.935,181.341 271.249,181.144  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "295.035,180.693 290.978,184.682 285.403,183.545 286.828,189.053 283.056,193.313    288.539,194.833 290.343,200.229 294.4,196.241 299.975,197.377 298.55,191.869 302.322,187.609 296.839,186.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "320.749,188.304 315.926,191.322 310.728,189.009 310.931,194.695 306.328,198.04    311.354,200.707 311.95,206.366 316.773,203.347 321.971,205.661 321.768,199.975 326.371,196.63 321.345,193.962  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGq);
export default __webpack_public_path__ + "static/media/gq.a12ba6b15f8825140a316e655dd0afd7.svg";
export { ForwardRef as ReactComponent };